<template>
  <div class="calls-table-cell tcell_7">
    <div
      v-if="call.vacation_info || !call.is_available"
      class="table-td-border-right calls-table-cell-inner-table 1"
    >
      <div class="o-tags u-no-padding text-right o-tag-btn-container">
        <ul class="o-tag-btn-area o-float-right">
          <li class="o-half-div">
            <a href="javascript: void(0)" class="c-tag-btn u-btn-red">
              <div v-if="call.vacation_info && !call.is_available">
                Unavailable due to vacation and recurring unavailability
              </div>
              <div v-else-if="!call.is_available">
                Unavailable due to recurring unavailability
              </div>
              <div v-else-if="call.vacation_info">
                Unavailable due to vacation
              </div>
              <div v-else>No call</div>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div
      v-else-if="call.is_available && call.booked_info"
      class="table-td-border-right calls-table-cell-inner-table 3"
    >
      <div class="o-tags u-no-padding text-right o-tag-btn-container">
        <ul class="o-tag-btn-area o-float-right">
          <li
            class="o-half-div"
            v-if="
              call.booked_info.client_id !== call.job.client_id &&
              call.booked_info.job_id !== call.job.id"
          >
            <a
              href="javascript: void(0)"
              class="c-tag-btn u-btn-orange"
            >
              OTHER BOOKING - {{ call.booked_info.subdomain }}
            </a>
          </li>

          <li v-else class="o-half-div">
            <a href="javascript: void(0)" class="c-tag-btn u-btn-blue">
              {{
                call.booked_info.label +
                ":" +
                getConflictDate(call.booked_info.start) +
                "(" +
                getTime(call.booked_info.start) +
                "-" +
                getTime(call.booked_info.end) +
                ")"
              }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div
      v-else-if="
        !call.vacation_info && call.is_available && call.call_actions.length > 0
      "
      class="table-td-border-right calls-table-cell-inner-table 4"
    >
      <div class="o-tags u-no-padding text-right o-tag-btn-container">
        <ul
          v-if="
            call.call_actions[call.call_actions.length - 1].action_name ==
            'Declined'
          "
          class="o-tag-btn-area o-float-right"
        >
          <li class="o-half-div" @click="openDeclinedModal(employee)">
            <a href="javascript: void(0)" class="c-tag-btn u-btn-red">
              Declined : {{ call.job.title }}
            </a>
          </li>
        </ul>

        <ul
          v-else-if="
            call.call_actions[call.call_actions.length - 1].action_name ==
            'Call Out'
          "
          class="o-tag-btn-area o-float-right"
        >
          <li class="o-half-div">
            <a href="javascript: void(0)" class="c-tag-btn u-btn-yellow">
              Called Out : {{ call.job.title }}
            </a>
          </li>
        </ul>

        <ul
          v-else-if="
            call.call_actions[call.call_actions.length - 1].action_name ==
            'Timed Out'
          "
          class="o-tag-btn-area o-float-right"
        >
          <li class="o-half-div">
            <a href="javascript: void(0)" class="c-tag-btn u-btn-yellow">
              Timed Out : {{ call.job.title }}
            </a>
          </li>
        </ul>

        <ul
          v-else-if="
            call.call_actions[call.call_actions.length - 1].action_name ==
            'Passed'
          "
          class="o-tag-btn-area o-float-right"
        >
          <li class="o-half-div">
            <a href="javascript: void(0)" class="c-tag-btn u-btn-yellow">
              Passed : {{ call.job.title }}
            </a>
          </li>
        </ul>

        <ul v-else class="o-tag-btn-area o-float-right">
          <li
            v-if="Object.keys(call.previous_call_info).length == 0"
            :class="{
              'o-half-div': true,
              'o-half-div-width': !isCurrentJobHTS(call.hts_info),
            }"
          >
            <a
              href="javascript: void(0)"
              :class="{
                'c-tag-btn u-btn-blue':
                  Object.keys(call.hts_info).length > 0 &&
                  isCurrentJobHTS(call.hts_info),
                'c-tag-btn u-btn-light-orange':
                  Object.keys(call.hts_info).length > 0 &&
                  !isCurrentJobHTS(call.hts_info),
                'c-tag-btn u-btn-green': Object.keys(call.hts_info).length == 0,
              }"
              >Last call 24:00+</a
            >
          </li>

          <li
            v-if="Object.keys(call.previous_call_info).length !== 0"
            :class="{
              'o-half-div': true,
              'o-half-div-width': !isCurrentJobHTS(call.hts_info),
            }"
          >
            <a
              href="javascript: void(0)"
              :class="{
                'c-tag-btn u-btn-blue':
                  Object.keys(call.hts_info).length > 0 &&
                  isCurrentJobHTS(call.hts_info),
                'c-tag-btn u-btn-light-orange':
                  Object.keys(call.hts_info).length > 0 &&
                  !isCurrentJobHTS(call.hts_info),
                'c-tag-btn u-btn-green':
                  Object.keys(call.hts_info).length == 0 &&
                  !checkTurnOver(call.previous_call_info),
                'c-tag-btn u-btn-yellow':
                  Object.keys(call.hts_info).length == 0 &&
                  checkTurnOver(call.previous_call_info),
              }"
            >
              {{ getPrevCallTime(call.previous_call_info) }}</a
            >
          </li>

          <li
            v-if="
              Object.keys(call.hts_info).length > 0 &&
              !isCurrentJobHTS(call.hts_info)
            "
            class="o-half-div o-half-div-width"
          >
            <a
              href="javascript: void(0)"
              class="c-tag-btn u-btn-light-orange"
              >{{ getJobTitle(call.hts_info) }}</a
            >
          </li>

          <li
            v-if="Object.keys(call.next_call_info).length == 0"
            :class="{
              'o-half-div': true,
              'o-half-div-width': !isCurrentJobHTS(call.hts_info),
            }"
          >
            <a
              href="javascript: void(0)"
              :class="{
                'c-tag-btn u-btn-blue':
                  Object.keys(call.hts_info).length > 0 &&
                  isCurrentJobHTS(call.hts_info),
                'c-tag-btn u-btn-light-orange':
                  Object.keys(call.hts_info).length > 0 &&
                  !isCurrentJobHTS(call.hts_info),
                'c-tag-btn u-btn-green': Object.keys(call.hts_info).length == 0,
              }"
              >Next call 24:00+</a
            >
          </li>

          <li
            v-if="Object.keys(call.next_call_info).length !== 0"
            :class="{
              'o-half-div': true,
              'o-half-div-width': !isCurrentJobHTS(call.hts_info),
            }"
          >
            <a
              href="javascript: void(0)"
              :class="{
                'c-tag-btn u-btn-blue':
                  Object.keys(call.hts_info).length > 0 &&
                  isCurrentJobHTS(call.hts_info),
                'c-tag-btn u-btn-light-orange':
                  Object.keys(call.hts_info).length > 0 &&
                  !isCurrentJobHTS(call.hts_info),
                'c-tag-btn u-btn-green':
                  Object.keys(call.hts_info).length == 0 &&
                  !checkTurnOver(call.next_call_info),
                'c-tag-btn u-btn-yellow':
                  Object.keys(call.hts_info).length == 0 &&
                  checkTurnOver(call.next_call_info),
              }"
            >
              {{ getNextCallTime(call.next_call_info) }}</a
            >
          </li>
        </ul>
      </div>
    </div>

    <div v-else class="table-td-border-right calls-table-cell-inner-table 2">
      <div class="o-tags u-no-padding text-right o-tag-btn-container">
        <ul class="o-tag-btn-area o-float-right">
          <li
            v-if="Object.keys(call.previous_call_info).length == 0"
            :class="{
              'o-half-div': true,
              'o-half-div-width': !isCurrentJobHTS(call.hts_info),
            }"
          >
            <a
              href="javascript: void(0)"
              :class="{
                'c-tag-btn u-btn-blue':
                  Object.keys(call.hts_info).length > 0 &&
                  isCurrentJobHTS(call.hts_info),
                'c-tag-btn u-btn-light-orange':
                  Object.keys(call.hts_info).length > 0 &&
                  !isCurrentJobHTS(call.hts_info),
                'c-tag-btn u-btn-green': Object.keys(call.hts_info).length == 0,
              }"
              >Last call 24:00+</a
            >
          </li>

          <li
            v-if="Object.keys(call.previous_call_info).length !== 0"
            :class="{
              'o-half-div': true,
              'o-half-div-width': !isCurrentJobHTS(call.hts_info),
            }"
          >
            <a
              href="javascript: void(0)"
              :class="{
                'c-tag-btn u-btn-blue':
                  Object.keys(call.hts_info).length > 0 &&
                  isCurrentJobHTS(call.hts_info),
                'c-tag-btn u-btn-light-orange':
                  Object.keys(call.hts_info).length > 0 &&
                  !isCurrentJobHTS(call.hts_info),
                'c-tag-btn u-btn-green':
                  Object.keys(call.hts_info).length == 0 &&
                  !checkTurnOver(call.previous_call_info),
                'c-tag-btn u-btn-yellow':
                  Object.keys(call.hts_info).length == 0 &&
                  checkTurnOver(call.previous_call_info),
              }"
            >
              {{ getPrevCallTime(call.previous_call_info) }}</a
            >
          </li>

          <li
            v-if="
              Object.keys(call.hts_info).length > 0 &&
              !isCurrentJobHTS(call.hts_info)
            "
            class="o-half-div o-half-div-width"
          >
            <a
              href="javascript: void(0)"
              class="c-tag-btn u-btn-light-orange"
              >{{ getJobTitle(call.hts_info) }}</a
            >
          </li>

          <li
            v-if="Object.keys(call.next_call_info).length == 0"
            :class="{
              'o-half-div': true,
              'o-half-div-width': !isCurrentJobHTS(call.hts_info),
            }"
          >
            <a
              href="javascript: void(0)"
              :class="{
                'c-tag-btn u-btn-blue':
                  Object.keys(call.hts_info).length > 0 &&
                  isCurrentJobHTS(call.hts_info),
                'c-tag-btn u-btn-light-orange':
                  Object.keys(call.hts_info).length > 0 &&
                  !isCurrentJobHTS(call.hts_info),
                'c-tag-btn u-btn-green': Object.keys(call.hts_info).length == 0,
              }"
              >Next call 24:00+</a
            >
          </li>

          <li
            v-if="Object.keys(call.next_call_info).length !== 0"
            :class="{
              'o-half-div': true,
              'o-half-div-width': !isCurrentJobHTS(call.hts_info),
            }"
          >
            <a
              href="javascript: void(0)"
              :class="{
                'c-tag-btn u-btn-blue':
                  Object.keys(call.hts_info).length > 0 &&
                  isCurrentJobHTS(call.hts_info),
                'c-tag-btn u-btn-light-orange':
                  Object.keys(call.hts_info).length > 0 &&
                  !isCurrentJobHTS(call.hts_info),
                'c-tag-btn u-btn-green':
                  Object.keys(call.hts_info).length == 0 &&
                  !checkTurnOver(call.next_call_info),
                'c-tag-btn u-btn-yellow':
                  Object.keys(call.hts_info).length == 0 &&
                  checkTurnOver(call.next_call_info),
              }"
            >
              {{ getNextCallTime(call.next_call_info) }}</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import dateTimeConvert from "../../timeConvert&Compare";
import { mapGetters } from "vuex";
import { bus } from "../../main.js";
import service from "../../services.js";

export default {
  props: {
    call: {
      type: Object,
      required: true,
    },
    tableapiheaders: {
      type: Object,
      required: true,
    },
    callStartTime: {
      type: String,
      required: false,
    },
    callEndTime: {
      type: String,
      required: false,
    },
    turnover: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      turnoverTime: " ",
      ignore_decline: " ",
    };
  },

  computed: {
    ...mapGetters({
      userToken: "userToken",
      userRole: "userRole",
      userClientID: "userClientID",
      userID: "userID",
      userRoleSlug: "userRoleSlug",
    }),
  },

  methods: {
    async openDeclinedModal(emp) {
      if (this.userRoleSlug != "employee") {
        await this.$confirm("Do you want to Un-Decline", "Un-Decline?", {
          confirmButtonText: "Undecline",
          cancelButtonText: "Cancel",
        })
          .then(async () => {
            await this.undeclinedCall(emp);
          })
          .catch(() => {});
      }
    },

    async undeclinedCall(emp) {
      await service
        .post(
          "call/undecline",
          {
            employee_id: emp.id,
            call_id: emp.call_actions[0].call_id,
            user_id: this.userID,
          },
          {
            Authorization: this.userToken,
            "cs3-context-role": this.userRole,
            "cs3-context-clientId": this.userClientID,
          }
        )
        .then((res) => {
          let action = "Decline";
          this.$Progress.finish();
          this.$notify({
            title: "Success",
            message: "Call undeclined successfully.",
            type: "success",
          });
          bus.$emit("callUnDecline", action);
        })
        .catch((err) => {
          console.log(err);
          this.$notify({
            title: "Warning",
            message: "Call undeclined Failed.",
            type: "warning",
          });
          this.$Progress.finish();
        });
    },

    isCurrentJobHTS(hts_list) {
      if (hts_list && !Array.isArray(hts_list)) {
        hts_list = Object.values(hts_list);
      }
      let flag = false;
      hts_list.forEach((hts) => {
        if (hts.job_id == this.tableapiheaders.employee_id) {
          flag = true;
        }
      });

      return flag;
    },

    getJobTitle(hts_list) {
      if (hts_list && !Array.isArray(hts_list)) {
        hts_list = Object.values(hts_list);
      }
      return hts_list && hts_list[0].job_name ? hts_list[0].job_name : " ";
    },

    getCallActionByType(call_action, type) {
      let declines = [],
        passes = [],
        timeouts = [],
        callouts = [];
      if (call_action && call_action.length) {
        call_action.forEach((call) => {
          switch (call.action_name) {
            case "Declined":
              declines.push(call);
              break;
            case "Call Out":
              callouts.push(call);
              break;
            case "Timed Out":
              timeouts.push(call);
              break;
            case "Passed":
              passes.push(call);
              break;
            default:
              // console.log("call Action not found switch 1");
          }
        });
      }
      switch (type) {
        case "Declined":
          return declines;
          break;
        case "Call Out":
          return callouts;
          break;
        case "Timed Out":
          return timeouts;
          break;
        case "Passed":
          return passes;
          break;
        default:
          // console.log("call Action not found switch 2");
      }
      return [];
    },

    getTime(dateTime) {
      return dateTimeConvert.globalTime(dateTime);
    },

    getConflictDate(dateTime) {
      return dateTimeConvert.withCustomFormat(dateTime, "DD MMM");
    },

    checkTurnOver(calls) {
      if (calls && Object.keys(calls).length) {
        let duration = calls[0].call_interval.split(":");
        if (duration.length >= 2 && Number(duration[0]) <= 24) {
          let hours = Number(duration[0]);
          if (hours < this.turnover) {
            return true;
          }
        }
      }
      return false;
    },

    getPrevCallTime(calls) {
      if (calls && Object.keys(calls).length) {
        let duration = calls[0].call_interval.split(":");
        if (duration.length >= 3 && Number(duration[0]) < 24) {
          return (
            "Last call " +
            moment(calls[0].call_interval, "HH:mm:ss").format("HH:mm") +
            "+"
          );
        }
      }
      return "Last call 24:00+";
    },

    getNextCallTime(calls) {
      if (calls && Object.keys(calls).length) {
        let duration = calls[0].call_interval.split(":");
        if (duration.length >= 3 && Number(duration[0]) < 24) {
          return (
            "Next call " +
            moment(calls[0].call_interval, "HH:mm:ss").format("HH:mm") +
            "+"
          );
        }
      }
      return "Next call 24:00+";
    },
  },

  created() {
    this.turnoverTime = this.turnover;
  },
};
</script>

<style scoped>
.u-btn-blue {
  background: #37bae8;
}
.o-half-div-width {
  width: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/calls/callListConflicts.vue